export const sortArray = (arrOfObjects: any[], sortBy = "sortable") => {
  if (arrOfObjects && arrOfObjects.length > 0)
    return arrOfObjects.sort((a, b) => a[sortBy] - b[sortBy]);

  return [];
};

export const stringBoolean = (someVariable: any) =>
  someVariable === true || someVariable === "1";

export const stripHtml = (str: string) => str.replace(/<[^>]+>/g, "");

export const direction = (language: string, languages: any[]) => {
  const index = languages?.findIndex((lang) => lang.code === language);
  if (index < 0) return "ltr";
  return languages[index].is_rtl ? "rtl" : "ltr";
};
export const getRndInteger = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1)) + min;
export const getRandom = () => {
  const date = new Date();
  return (
    getRndInteger(1e6, 1e7) +
    (date.getSeconds() + date.getMilliseconds())?.toString()
  );
};
export const hexToRGBA = (hex: string, opacity: number) => {
  return (
    "rgba(" +
    (hex = hex.replace("#", ""))
      .match(new RegExp("(.{" + hex.length / 3 + "})", "g"))
      ?.map(function (l) {
        return parseInt(hex.length % 2 ? l + l : l, 16);
      })
      .concat(isFinite(opacity) ? opacity : 1)
      .join(",") +
    ")"
  );
};

export const getSliderScrollIndex = (
  sliderWidth: number,
  widthArr: number[],
  selectedIndex: number
) => {
  let sum = 0;
  let index: number;
  for (index = widthArr.length - 1; index >= 0; index--) {
    sum += widthArr[index];
    if (sum >= sliderWidth) break;
  }
  return selectedIndex > index ? index + 1 : selectedIndex;
};
export const formatServerDateTime = (date: Date) => {
  if (!date || date?.toString() === "") return "";
  let year = date.getFullYear();
  let month = (date.getMonth() + 1)?.toString().padStart(2, "0");
  let day = date.getDate()?.toString().padStart(2, "0");
  let hours = date.getHours()?.toString().padStart(2, "0");
  let minutes = date.getMinutes()?.toString().padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}`;
};
